import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/eye.svg'
import _imports_1 from '@/app/ui/assets/svg/invisible.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'


const _hoisted_1 = {
  key: 0,
  class: "inline-block relative w-full"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "h-6"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "h-6"
}
const _hoisted_4 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 mr-10 mt-4" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "inline-block relative w-full"
}
const _hoisted_7 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    (_ctx.isPassword)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("input", {
            type: _ctx.passwordType,
            "v-model": _ctx.password,
            placeholder: _ctx.placeholder,
            class: ["w-full mt-4 h-10 pl-4 border shadow-md font-montserrat focus:outline-none", {
          'border-red-lp-700': _ctx.errorPassword,
          'border-2': !_ctx.errorPassword
        }]
          }, null, 10, ["type", "v-model", "placeholder"]),
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPassword && _ctx.showPassword(...args))),
            class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-6 pt-4 text-gray-500 focus:outline-none"
          }, [
            (_ctx.iconType === 'eye')
              ? (_openBlock(), _createBlock("img", _hoisted_2))
              : (_openBlock(), _createBlock("img", _hoisted_3))
          ]),
          _withDirectives(_createVNode("div", _hoisted_4, [
            _hoisted_5
          ], 512), [
            [_vShow, _ctx.errorPassword]
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("input", {
            type: "text",
            "v-model": _ctx.value,
            placeholder: _ctx.placeholder,
            class: ["w-full h-10 pl-4 border shadow-md font-montserrat focus:outline-none", {
          'border-red-700': _ctx.errorValue,
          'border-2': !_ctx.errorValue
        }]
          }, null, 10, ["v-model", "placeholder"]),
          _withDirectives(_createVNode("div", _hoisted_7, [
            _hoisted_8
          ], 512), [
            [_vShow, _ctx.errorValue]
          ])
        ]))
  ]))
}